import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { enhancedConnect } from "../../utils";
import { TabTypes, TabsContextProvider, TabsRenderMode } from "./context";
import { TabsContainer } from "./TabsContainer";
import { SegmentedContainer } from "./SegmentedContainer";
export { TabsItem } from "./TabsItem";
var _AutoTabs = function _AutoTabs(_ref) {
  var children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? TabTypes.CHIPS : _ref$type,
    wrapTabs = _ref.wrapTabs,
    _ref$alignTabs = _ref.alignTabs,
    alignTabs = _ref$alignTabs === void 0 ? 'center' : _ref$alignTabs,
    className = _ref.className;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    activeIndex = _useState4[0],
    setActiveIndex = _useState4[1];
  var onChange = function onChange(newIndex) {
    return function (newValue) {
      setValue(newValue);
      setActiveIndex(newIndex);
    };
  };
  var itemsLength = React.Children.count(children) || 0;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-Tabs"
  }, type === TabTypes.SEGMENTED && /*#__PURE__*/React.createElement(SegmentedContainer, {
    activeIndex: activeIndex,
    itemsLength: itemsLength
  }, React.Children.map(children, function (node, index) {
    return /*#__PURE__*/React.createElement(TabsContextProvider, {
      isFirst: index === 0,
      mode: TabsRenderMode.TAB,
      onChange: onChange(index),
      type: type,
      value: value
    }, node);
  })), type !== TabTypes.SEGMENTED && /*#__PURE__*/React.createElement(TabsContainer, {
    align: alignTabs,
    type: type,
    wrap: wrapTabs
  }, React.Children.map(children, function (node, index) {
    return /*#__PURE__*/React.createElement(TabsContextProvider, {
      isFirst: index === 0,
      mode: TabsRenderMode.TAB,
      onChange: onChange(index),
      type: type,
      value: value
    }, node);
  })), React.Children.map(children, function (node, index) {
    return /*#__PURE__*/React.createElement(TabsContextProvider, {
      isFirst: index === 0,
      mode: TabsRenderMode.CONTENT,
      onChange: onChange(index),
      value: value
    }, node);
  }));
};
export var AutoTabs = enhancedConnect({
  children: PropTypes.node,
  wrapTabs: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(TabTypes)),
  alignTabs: PropTypes.oneOf(['left', 'center', 'right'])
})(_AutoTabs);